import { VENUE_SELECTED } from '../actions/actionTypes';

export default function venueReducer(state = { selected: null }, action) {
  switch (action.type) {
    case VENUE_SELECTED:
      return { selected: action.venue };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/venue.js